import {AUTH_TOKEN} from "../constants/Auth";

export const getToken = () => localStorage.getItem(AUTH_TOKEN)
    ? localStorage.getItem(AUTH_TOKEN)
    : null;

export const getAuthorizationHeader = () => `${getToken()}`;